import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AccountIdService, AgencyIdService} from "../account.service";
import {CurrentRouteService} from "../currentRoute.service";

@Component({
  selector: 'app-integrations-redirect',
  templateUrl: './integrations-redirect.component.html',
  styleUrls: ['./integrations-redirect.component.css']
})
export class IntegrationsRedirectComponent implements OnInit {

  network: string;

  constructor(public router: Router,
              private route: ActivatedRoute,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private currentrouteService: CurrentRouteService,) { }

  ngOnInit(): void {

    this.currentrouteService.announceCurrentRoute(this.router.url);
    let query_parms = this.route.snapshot.queryParamMap;
    this.network = query_parms.get('network');
    //let is_account_route = query_parms.get('statusCode');



  } // end ngOnInit

  popClose() {
    //https://stackoverflow.com/questions/70403101/close-browser-tab-window-in-angular
    window.self.close();
  }

} //end of class
